import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatusPill } from "@/components/ui-helpers";

const CONNECTOR_NAMES = {
  zoho: "Zoho CRM", meta: "Meta Ads", typeform: "Typeform", calendly: "Calendly",
  gcal: "Google Calendar", gmail: "Gmail", wati: "Wati", zapier: "Zapier",
  mailerlite: "MailerLite", slack: "Slack",
};

export default function Skills() {
  const [skills, setSkills] = useState([]);
  const [conns, setConns] = useState([]);

  useEffect(() => {
    api.get("/skills").then((r) => setSkills(r.data.skills));
    api.get("/connectors/status").then((r) => setConns(r.data.connectors));
  }, []);

  return (
    <div data-testid="skills-page">
      <PageHeader
        title="Skills & connectors"
        sub="Status only in Phase 1. All skills activate in Phase 3 (Claude API)."
      />
      <div className="p-4 md:p-6 space-y-6">
        <section>
          <h2 className="text-sm font-medium mb-3">Connectors</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="connectors-grid">
            {conns.map((c) => (
              <div key={c.id} className="panel p-3 flex items-center justify-between gap-2" data-testid={`conn-row-${c.id}`}>
                <div>
                  <div className="text-sm">{CONNECTOR_NAMES[c.id] || c.id}</div>
                  <div className="text-[11px] text-neutral-500">
                    {c.last_sync ? `Last sync ${new Date(c.last_sync).toLocaleString("en-IN")}` : "Never synced"}
                  </div>
                </div>
                <StatusPill status={c.status} />
              </div>
            ))}
          </div>
        </section>
        <section>
          <h2 className="text-sm font-medium mb-3">Skills</h2>
          <div className="panel overflow-x-auto">
            <table className="table-dense w-full">
              <thead className="border-b border-[var(--border)]">
                <tr>
                  <th className="px-3 py-2 text-left">Skill</th>
                  <th className="px-3 py-2 text-left">Trigger</th>
                  <th className="px-3 py-2 text-left">Does</th>
                  <th className="px-3 py-2 text-left">Writes to</th>
                  <th className="px-3 py-2 text-left">Last run</th>
                  <th className="px-3 py-2 text-left">State</th>
                </tr>
              </thead>
              <tbody>
                {skills.map((s) => (
                  <tr key={s.id} className="border-b border-[var(--border)]">
                    <td className="px-3 py-2 font-mono text-neutral-300">{s.id}</td>
                    <td className="px-3 py-2 text-neutral-400">{s.trigger}</td>
                    <td className="px-3 py-2">{s.does}</td>
                    <td className="px-3 py-2 text-neutral-400">{s.writes_to}</td>
                    <td className="px-3 py-2 text-neutral-500">{s.last_run || "—"}</td>
                    <td className="px-3 py-2">
                      <span className="pill">P{s.phase} · off</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
        <section className="panel p-4">
          <h2 className="text-sm font-medium mb-2">Guardrails</h2>
          <ul className="text-xs text-neutral-400 space-y-1 list-disc pl-5">
            <li>Ask before adding CRM tasks outside cadence</li>
            <li>Client-facing messages require one-tap approval</li>
            <li>Funnel publish &amp; budget changes admin-only, dummy-lead test required</li>
            <li>Date changes with no logged work are flagged invalid</li>
            <li>Nothing deleted or overwritten; every edit becomes a new event</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
